import { useState } from 'react'
import { get } from '../../http/restservice'
import { useNavigate } from 'react-router-dom'
import env from '../../env/env'
import { toast } from 'sonner'
import { AuthFloatingInput, AuthFloatingPhoneInput } from '../../Components/Auth/AuthFloatingInput'
import { darkGridStyle } from '../../Components/Auth/AuthCarousel'
import { Button } from '../../Components/ui/button'

const ADMIN_ADD_PLAN_PATH =
  '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/addPlan'

const normalizePhoneNumber = (value) => {
  if (!value) return ''
  return value.startsWith('+91') ? value : `+91${String(value).replace(/^\+91/, '')}`
}

const fetchCustomerDetails = async (phoneNumber) => {
  const encodedPhone = encodeURIComponent(phoneNumber)
  const url = `${env.API_URL}customerservice/api/customer/details/${encodedPhone}`

  try {
    const response = await get(url)
    if (!response || response.isError) {
      return response
    }

    // Keep the same session/nav shape AddPlan and holdings already expect: { data: customer }
    const normalized = {
      code: response.code,
      status:
        response.code === '200' && String(response.customerFound) === 'true' ? 'SUCCESS' : 'FAILED',
      data: response.customerDetails,
      customerFound: response.customerFound,
    }

    if (normalized.status === 'SUCCESS' && normalized.data) {
      sessionStorage.setItem('actionPlanUser', JSON.stringify(normalized))
    }

    return normalized
  } catch (error) {
    console.log(error, 'Error Occured')
  }
}

const ActionPlan = () => {
  const [uccId, setUccId] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const navigate = useNavigate()

  const handlePhoneChange = (value) => {
    setPhoneNumber(value ?? '')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const normalizedPhone = normalizePhoneNumber(phoneNumber.trim())
    if (!normalizedPhone || normalizedPhone.replace(/\D/g, '').length < 10) {
      toast.error('Client phone number is required')
      return
    }

    setIsSubmitting(true)
    try {
      const res = await fetchCustomerDetails(normalizedPhone)

      if (res?.code === '200' && res?.status === 'SUCCESS' && res?.data) {
        const enteredClientCode = uccId?.trim().toUpperCase()
        const returnedClientCode = res.data?.uid?.split('-')?.[0]?.toUpperCase()

        if (enteredClientCode && returnedClientCode && enteredClientCode !== returnedClientCode) {
          toast.error(
            `Client code mismatch. Expected ${enteredClientCode}, found ${returnedClientCode}`,
          )
          return
        }

        toast.success('Login successful')
        navigate(ADMIN_ADD_PLAN_PATH, {
          state: {
            data: res.data,
          },
        })
      } else {
        toast.error('Login unsuccessful')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className='relative flex min-h-[100svh] w-full items-center justify-center overflow-hidden bg-[#040313] px-4 py-10'>
      <div
        aria-hidden='true'
        className='pointer-events-none absolute inset-0 z-0 opacity-70'
        style={darkGridStyle}
      />

      <div className='relative z-10 mx-auto flex w-full max-w-[360px] min-w-0 flex-col items-center lg:max-w-[432px]'>
        <img
          src={`${env.SVGS}/newlogo.svg`}
          alt='Fabits'
          className='mb-8 h-8 w-auto object-contain'
        />

        <div className='mb-8 flex w-full flex-col gap-y-1'>
          <h1 className='text-center font-IBM text-[28px] font-bold leading-9 text-white lg:text-[36px] lg:leading-10'>
            Admin Access
          </h1>
          <p className='text-center font-IBM text-sm font-medium leading-5 text-black-300'>
            Sign in with client details to continue
          </p>
        </div>

        <form onSubmit={handleSubmit} className='flex w-full min-w-0 flex-col gap-y-5 font-IBM'>
          <AuthFloatingPhoneInput
            label='Client Phone Number'
            phoneNumber={phoneNumber}
            setPhoneNumber={handlePhoneChange}
            darkSurface
          />

          <AuthFloatingInput
            id='uccId'
            name='uccId'
            label='Client Code (optional)'
            value={uccId}
            onChange={(e) => setUccId(e.target.value)}
            darkSurface
            required={false}
            autoComplete='off'
          />

          <Button
            type='submit'
            disabled={isSubmitting}
            className='login-btn mt-1 h-11 w-full rounded-xl bg-primary-500 text-sm font-semibold text-white shadow-[0_10px_24px_rgba(40,24,255,0.18)] hover:bg-[#2818ff] disabled:bg-[#97aaff] disabled:opacity-100'
          >
            {isSubmitting ? 'Submitting...' : 'Continue'}
          </Button>
        </form>
      </div>
    </div>
  )
}

export default ActionPlan
